import { render, staticRenderFns } from "./Gantt2.vue?vue&type=template&id=6d8ab1ca&scoped=true&"
import script from "./Gantt2.vue?vue&type=script&lang=js&"
export * from "./Gantt2.vue?vue&type=script&lang=js&"
import style0 from "./Gantt2.vue?vue&type=style&index=0&id=6d8ab1ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ab1ca",
  null
  
)

export default component.exports